
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Code, Preview } from "@lighting-beetle/lighter-styleguide";
import Icon from "../../Icon/";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};
const Note = makeShortcode("Note");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Typography utilities`}</h1>
    <p>{`Text utility classes provides basic functionality such as alignment or text transform. There are also utility classes for text colors.`}</p>
    <Note title="HTML semantics" mdxType="Note">
  Always consider using semantic HTML when styling text (strong, em).
    </Note>
    <h2>{`Font styles`}</h2>
    <Preview disableCode mdxType="Preview">
  <Code mdxType="Code">.text-bold</Code> <span className="text-bold">text bold</span>
  <br />
  <Code mdxType="Code">.text-semibold</Code>{" "}
  <span className="text-semibold">text semibold</span>
  <br />
  <Code mdxType="Code">.text-light</Code> <span className="text-light">text light</span>
  <br />
  <Code mdxType="Code">.text-italic</Code> <span className="text-italic">text italic</span>
  <br />
  <Code mdxType="Code">.text-normal</Code> <span className="text-normal">text normal</span>
    </Preview>
    <h2>{`Text colors`}</h2>
    <Preview disableCode mdxType="Preview">
  <Code mdxType="Code">.text-color-primary</Code>{" "}
  <span className="text-color-primary">Primary text</span>
  <br />
  <Code mdxType="Code">.text-color-secondary</Code>{" "}
  <span className="text-color-secondary">Secondary text</span>
  <br />
  <Code mdxType="Code">.text-color-grey</Code>{" "}
  <span className="text-color-grey">Grey text</span>
  <br />
  <Code mdxType="Code">.text-color-black</Code>{" "}
  <span className="text-color-black">Black text</span>
  <br />
  <Code mdxType="Code">.text-color-white</Code>{" "}
  <span className="text-color-white">White text</span>
  <br />
  <Code mdxType="Code">.text-color-error</Code>{" "}
  <span className="text-color-error">Error text</span>
  <br />
  <Code mdxType="Code">.text-color-success</Code>{" "}
  <span className="text-color-success">Success text</span>
    </Preview>
    <h2>{`Text align`}</h2>
    <Preview disableCode mdxType="Preview">
  <p className="text-left">
    <Code mdxType="Code">.text-left</Code>
  </p>
  <p className="text-center">
    <Code mdxType="Code">.text-center</Code>
  </p>
  <p className="text-right">
    <Code mdxType="Code">.text-right</Code>
  </p>
  <p className="text-justify" style={{
        width: "200px"
      }}>
    <Code mdxType="Code">.text-justify</Code>Lorem ea dolor ea exercitation et esse incididunt
    ut Excepteur officia Ut sint cupidatat cupidatat
  </p>
    </Preview>
    <h2>{`Text vertical align`}</h2>
    <Preview disableCode mdxType="Preview">
  <p>
    Icon <Icon name="heart" size="xlarge" className="text-vam" mdxType="Icon" /> with{" "}
    <Code mdxType="Code">.text-vam</Code>
  </p>
  <p>
    Icon <Icon name="heart" size="xlarge" className="text-vat" mdxType="Icon" /> with{" "}
    <Code mdxType="Code">.text-vat</Code>
  </p>
  <p>
    Icon <Icon name="heart" size="xlarge" className="text-vab" mdxType="Icon" /> with{" "}
    <Code mdxType="Code">.text-vab</Code>
  </p>
  <p>
    Icon <Icon name="heart" size="xlarge" className="text-vabl" mdxType="Icon" /> with{" "}
    <Code mdxType="Code">.text-vabl</Code>
  </p>
    </Preview>
    <h2>{`Text transform`}</h2>
    <Preview disableCode mdxType="Preview">
  <Code mdxType="Code">.text-transform-upper</Code>{" "}
  <span className="text-transform-upper">text transform uppercase</span>
  <br />
  <Code mdxType="Code">.text-transform-capitalize</Code>{" "}
  <span className="text-transform-capitalize">text transform capitalize</span>
  <br />
  <Code mdxType="Code">.text-transform-none</Code>{" "}
  <span className="text-transform-none">text transform none</span>
    </Preview>
    <h2>{`Text wrapping`}</h2>
    <Preview disableCode mdxType="Preview">
  <p className="text-nowrap">
    <Code mdxType="Code">.text-nowrap</Code> Text no warp ea dolor ea exercitation et esse
    incididunt ut Excepteur officia. Tempor officia minim cillum do aute nulla
    sint dolor Lorem proident nisi elit.
  </p>
  <p className="text-ellipsis" style={{
        width: "200px"
      }}>
    <Code mdxType="Code">.text-ellipsis</Code> Text ellipsis ea dolor ea exercitation et esse
    incididunt ut Excepteur officia. Tempor officia minim cillum do aute nulla
    sint dolor Lorem proident nisi elit.
  </p>
    </Preview>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;